import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Typography": Typography, "@mui/material/Breadcrumbs": Breadcrumbs, "@mui/material/Link": Link, "@mui/icons-material/Home": HomeIcon, "@mui/icons-material/Whatshot": WhatshotIcon, "@mui/icons-material/Grain": GrainIcon } } });
export default ClientProvider;
